import React from 'react';
import PropTypes from 'prop-types';

import * as liveCameraService from '../../../../services/idverification/LiveCameraService';

import styles from '../../testOverview.scss';

class LiveCamera extends React.PureComponent {
    static propTypes = {
        stream: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.videoRef = React.createRef();
    }

    componentDidMount() {
        this.setStream();
    }

    componentDidUpdate() {
        this.setStream();
    }

    setStream() {
        liveCameraService.setStream(this.videoRef.current, this.props.stream);
    }

    render() {
        return (
            <div className={styles.LiveCamera}>
                {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                <video autoPlay muted ref={this.videoRef} />
            </div>
        );
    }
}

export default LiveCamera;
